import {useQuery} from "@tanstack/react-query";
import {apiGetContext} from "./api/ApiApp";
import {useCallback, useEffect, useState} from "react";

const useAppContext = () => {
  const contextQuery = useQuery(apiGetContext());

  const contextQueryData = contextQuery.status === "success" ? contextQuery.data : {};

  const [sitesStatuses, setSitesStatuses] = useState(contextQueryData.sitesStatuses || []);
  const [allSitesStatuses, setAllSitesStatuses] = useState(contextQueryData.sitesStatuses || []);
  const [activeWorkers, setActiveWorkers] = useState(contextQueryData.workers || []);

  useEffect(() => {
    if (contextQuery.isSuccess) {
      setSitesStatuses(contextQueryData.sitesStatuses.filter(s => !s.deleteTime));
      setAllSitesStatuses(contextQueryData.sitesStatuses);
      setActiveWorkers(contextQueryData.workers.filter(worker => !worker.deleteTime));
    }
  }, [contextQuery.isSuccess, contextQueryData]);

  const getSiteStatus = useCallback(status => allSitesStatuses.find(s => s.id === status), [allSitesStatuses]);

  const getDefaultSiteStatus = useCallback(() => sitesStatuses.find(s => s.defaut), [sitesStatuses]);

  return {
    sitesStatuses,
    getSiteStatus,
    getDefaultSiteStatus,
    activeWorkers,
  };
};

export default useAppContext;
